const { Utils } = window.BAO

class AdventCalendarItems extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['items', 'item', 'loadMore', 'trigger']
  }

  connectedCallback () {
    super.connectedCallback()

    this.onResize = Utils.debounce(this.update.bind(this), 150)

    this.update()

    // Catches late-loading CSS/fonts/images shifting row heights after the
    // initial measurement, mirroring the accordion-drawer's same fix.
    const resizeObserver = new ResizeObserver(() => this.update())
    resizeObserver.observe(this)

    window.setTimeout(() => resizeObserver.disconnect(), 3000)
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.els.trigger.element, 'click', () => this.expand())
    this.listeners.add(window, 'resize', () => this.onResize())
  }

  update () {
    if (this.isExpanded) return

    const rows = this.groupItemsByRow(this.els.item.elements)

    if (rows.length <= this.rowsToShow) {
      this.expand({ animate: false })
      return
    }

    const rowHeight = rows[1][0].offsetTop - rows[0][0].offsetTop
    const collapsedHeight = rowHeight * (this.rowsToShow + 0.5)

    this.style.setProperty('--AdventItems_RowHeight', `${rowHeight}px`)
    this.itemsEl.style.setProperty('max-height', `${collapsedHeight}px`)

    rows.forEach((row, index) => {
      row.forEach(item =>
        item.toggleAttribute('inert', index >= this.rowsToShow),
      )
    })

    this.els.loadMore.element.hidden = false
  }

  expand ({ animate = true } = {}) {
    this.els.item.elements.forEach(item => item.removeAttribute('inert'))

    if (!animate) {
      this.setAttribute('data-advent-calendar-items-expanded', 'true')
      this.itemsEl.style.removeProperty('max-height')
      this.els.loadMore.element.hidden = true
      return
    }

    const fullHeight = this.itemsEl.scrollHeight

    this.itemsEl.style.setProperty(
      'max-height',
      `${this.itemsEl.getBoundingClientRect().height}px`,
    )

    // eslint-disable-next-line no-unused-expressions
    this.itemsEl.offsetHeight

    this.setAttribute('data-advent-calendar-items-expanded', 'true')
    this.itemsEl.style.setProperty('max-height', `${fullHeight}px`)

    this.listeners.add(
      this.itemsEl,
      'transitionend',
      () => {
        this.itemsEl.style.removeProperty('max-height')
        this.els.loadMore.element.hidden = true
      },
      { once: true },
    )
  }

  /**
   * @param {HTMLElement[]} items
   *
   * @returns {HTMLElement[][]}
   */
  groupItemsByRow (items) {
    return items.reduce((rows, item) => {
      const row = rows.find(r => r[0].offsetTop === item.offsetTop)

      if (row) {
        row.push(item)
      } else {
        rows.push([item])
      }

      return rows
    }, [])
  }

  get itemsEl () {
    return this.els.items.element
  }

  get isExpanded () {
    return this.getAttribute('data-advent-calendar-items-expanded') === 'true'
  }

  get rowsToShow () {
    return ['lg', 'xl'].includes(Utils.viewportSize()) ? 1 : 2
  }
}

if (!customElements.get('advent-calendar-items')) {
  customElements.define('advent-calendar-items', AdventCalendarItems)
}
